<template>
  <router-link :to="to"
    ><div><span>{{ title }}</span> <img src="@/assets/icons/icon_arrow.svg" alt="" /></div
  ></router-link>
</template>

<script>
export default {
  name: "Button",
  components: {},
  props: {
    to: String,
    title: String,
  },
};
</script>


<style lang="scss" scoped>
a {
  height: 65px;
  width: 220px;
  box-sizing: border-box;
  border-radius: 3px;
  div {
    position: relative;
    display:flex;
    width: 100%;
    span {
      flex-grow: 1;
    }
  }
  text-decoration: none;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-transform: uppercase;

  font-family: "Gotham";
  font-size: 1em;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 1em;
  padding-left: 36px;
  padding-right: 30px;
  border: 1px solid #ffd62f;
}
</style>
